"use client";

import { Heading, Paragraph } from "@/components/ui/typography";

import { useEffect, useState, useMemo } from "react";
import Navigation from "./_components/Navigation-new";
import Header from "./_components/Header";
import { createDocument } from "@/lib/text-utils";
import { content } from "./data/california-privacy-notice.data";

const ContentRenderer = ({ content, index }) => {
  return (
    <div className="mb-6" id={content.id}>
      <Heading variant="h2" className="capitalize">
        {index + 1}. {content.title}
      </Heading>
      <div
        className="prose max-w-none text-midnightIndigo-400"
        dangerouslySetInnerHTML={{ __html: content.content }}
      />

      {content.subContent.map(item => {
        return (
          <div key={item.id} className="my-3" id={item.id}>
            <Heading variant="h4">{item.title}</Heading>
            <Paragraph>{item.content}</Paragraph>
            {item.children ? (
              <div
                className="prose max-w-none text-midnightIndigo-400"
                dangerouslySetInnerHTML={{ __html: item.children }}
              />
            ) : null}
          </div>
        );
      })}
    </div>
  );
};

const generateTermsData = () => {
  return createDocument("terms-of-service", "", content);
};

export default function Page() {
  const [menuData, setMenuData] = useState([]);

  // Memoize the terms data
  const pageData = useMemo(() => generateTermsData(), []);

  useEffect(() => {
    if (pageData) {
      const menu = pageData.content.map((item, index) => ({
        id: item.id,
        number: `${index + 1}`,
        title: item.title,
        subMenu: item.subContent
          .filter(subItem => subItem.title)
          .map(subItem => ({
            id: subItem.id,
            number: subItem.title.split(" ")[0],
            title: subItem.title.split(" ").slice(1).join(" "),
          })),
      }));
      setMenuData(menu);
    }
  }, [pageData]);

  // Add scroll margin effect
  useEffect(() => {
    // Add scroll-margin-top to all sections
    const sections = document.querySelectorAll("[id]");
    sections.forEach(section => {
      section.style.scrollMarginTop = "100px";
    });
  }, []);

  return (
    <>
      <Header data={{ ...pageData, updatedOn: new Date("2025-03-27").toISOString() }} />
      <main className="relative mx-auto max-w-[1440px]">
        <section className="landing-container mt-[32px] flex max-w-[1440px] justify-between gap-2 md:mt-[64px] lg:gap-4">
          <div className="hidden w-[410px] md:block">
            <Navigation menu={menuData || []} />
          </div>
          <div className="mb-[32px] w-full md:mb-[124px]">
            <Paragraph className="mb-2">
              This California Privacy Notice supplements the information contained in the Privacy
              Policy of Wireless World and applies solely to California residents. We adopt this
              notice to comply with the California Consumer Privacy Act of 2018 (CCPA) as amended by
              the California Privacy Rights Act (CPRA) and other California privacy laws. Any terms
              defined in the CCPA/CPRA have the same meaning when used in this notice.
            </Paragraph>
            {pageData &&
              pageData.content.map((item, index) => (
                <ContentRenderer key={item.id} content={item} index={index} />
              ))}
          </div>
        </section>
      </main>
    </>
  );
}
